import React, {useState} from 'react'
import {connect} from "react-redux";
import ChooseSignatureTypePopup from "./ChooseSignatureTypePopup";
import reduxStore from "redux/store"
import {clearSignature} from "../../../redux/actions";
import Szafir from "./Szafir";
import {useDidUpdateEffect} from "../../../hooks/useDidUpdateEffect";
import PropTypes from "prop-types";
import {SignatureType} from "../../../constants/SignatureType";
import ExternalSignature from "./ExternalSignature";
// const useStyle = makeStyles(theme => ({
//     root: {}
// }))

function Signature(
    {
        config,
    }) {

    const [sigType, setSigType] = useState(null);

    useDidUpdateEffect(()=> {
        if(!config) {
            setSigType(null);
        }
    },[config])

    const cancel = () => {
        reduxStore.dispatch(clearSignature("config"));
        if(config.cancelCallback)
            config.cancelCallback();
    }


    return (
        <>
            {(!!config && sigType === null) && <ChooseSignatureTypePopup
                signatureTypes={config.signatureTypes}
                onSuccess={(selectedType) => setSigType(selectedType)}
                onCancel={cancel}
            />}
            <ExternalSignature signatureType={sigType} setSignatureType={setSigType} config={config} />
            <Szafir signatureType={sigType} setSignatureType={setSigType} config={config} />
        </>
    )

}

Signature.propTypes = {
    config: PropTypes.shape({
        docContentFunc: PropTypes.func.isRequired,
        successCallback: PropTypes.func.isRequired,
        errorCallback: PropTypes.func.isRequired,
        cancelCallback: PropTypes.func.isRequired,
        signatureTypes: PropTypes.arrayOf(PropTypes.oneOf(Object.keys(SignatureType))),
        getEncryptionRoundId: PropTypes.func.isRequired,
    })

}

Signature.defaultProps = {}

export default connect((state) => ({
    config: state.signature.config
}))(Signature);
